import { BooleanColumn, CategoricalColumn, NumericalColumn } from 'baseui/data-table';
import { CustomDateColumn, EMPTY_STRING } from 'commons-ui';

export const COL_NAMES = {
	segmentName: 'segmentName',
	isActive: 'isActive',
	cashbackRewardPer: 'cashbackRewardPer',
	createdAt: 'createdAt',
	updatedAt: 'updatedAt',
	code: 'code'
};

export const columnConfigs = [
	CategoricalColumn({
		title: 'Segment Name',
		mapDataToValue: (data: any) => {
			return data[COL_NAMES.segmentName] || EMPTY_STRING;
		},
		maxWidth: 450
	}),
	BooleanColumn({
		title: 'isActive',
		mapDataToValue: (data: any) => data[COL_NAMES.isActive],
		maxWidth: 200
	}),
	NumericalColumn({
		title: 'Cashback Reward Percentage',
		mapDataToValue: (data: any) => data[COL_NAMES.cashbackRewardPer],
		maxWidth: 200
	}),
	CustomDateColumn({
		title: 'Created At',
		minWidth: 150,
		maxWidth: 200,
		columnName: COL_NAMES.createdAt
	}),
	CustomDateColumn({
		title: 'Updated At',
		minWidth: 150,
		maxWidth: 200,
		columnName: COL_NAMES.updatedAt
	})
];

export const activeFilter = [
	{
		columnKey: 'Is Disabled',
		filterLabel: 'Active Coupons',
		filterValue: false
	}
];
